/**
 * What kind of browser this is, in words a support person can read.
 *
 * For the Help report's diagnostics. It returns a short family and major
 * version ("Chrome 140"), never the full user agent string, which carries
 * more than support needs.
 */

import { browserWindow, type Adapter } from './host.js';

export interface Environment extends Adapter {
  readonly browserLabel: () => string;
  readonly language: () => string | null;
}

const FAMILIES: readonly (readonly [string, RegExp])[] = [
  ['Edge', /Edg(?:e|A|iOS)?\/(\d+)/],
  ['Firefox', /(?:Firefox|FxiOS)\/(\d+)/],
  ['Chrome', /(?:Chrome|CriOS)\/(\d+)/],
  ['Safari', /Version\/(\d+)[.\d]* (?:Mobile\/\S+ )?Safari/],
];

export function browserLabelFor(userAgent: string): string {
  for (const [name, pattern] of FAMILIES) {
    const match = pattern.exec(userAgent);
    if (match?.[1] !== undefined) return `${name} ${match[1]}`;
  }
  return 'Unknown browser';
}

export const environment: Environment = {
  isSupported: () => browserWindow() !== null,
  browserLabel: () => browserLabelFor(browserWindow()?.navigator.userAgent ?? ''),
  language: () => browserWindow()?.navigator.language ?? null,
};
